import { Children, cloneElement } from 'react';

import { useInterviewsPutQueryById } from '../../../Common/Queries/interviewsQueries';

/**
 * this function is utility function for formate the data in required formate
 * @param {*} values remaining values
 * @param {*} editedValue edited values
 * @returns values in required formate
 */
export const formateData = (values, editedValue) => {
  const basicInfo = {
    round: values.round,
    status: values.status,
    text: editedValue.reason,
  };
  const otherDetails = {
    versionKey: values.versionKey,
    customLink: values.customLink || '',
    message: values.message || '',
    timeZone: 'Asia/Kolkata',
  };
  const interviewDetails = {
    interviewer: values.interviewer,
    startTime: Math.floor(new Date(editedValue.time) / 1000),
    duration: editedValue.duration,
    location: values.location || 'ONLINE',
    ...(editedValue?.isUpdateStartTime && { isUpdateStartTime: editedValue.isUpdateStartTime }),
  };
  return {
    interviewDetails,
    otherDetails,
    basicInfo,
    application: values.application,
  };
};

export function RescheduleContainer({ children, interview, id }) {
  const putToInterview = useInterviewsPutQueryById();

  const handleReschedule = (finalValues) => {
    const reqBody = formateData(interview, finalValues);
    const reqParams = { reqBody, reqId: id };
    putToInterview.mutate(reqParams);
  };

  return Children.only(cloneElement(children, { handleReschedule, putToInterview, interview }));
}
